
import { axiosGet, axiosPost, axiosPut, axiosDelete } from "../options/header"

const starter = '/cases'


export default {
    getAll() {
      try {
        return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + starter + '/file/tags', {
          params: {},
          credentials: true
        });
      } catch (err) {
        console.error("[FileTagging] Failed to fetch tags:", err);
        throw err;
      }
    },

    getCaseFileTags(case_id) {
      try {
        return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + starter + "/case/" + case_id + "/file/tags", {
          params: {},
          credentials: true
        });
      } catch (err) {
        console.error("[FileTagging] Failed to fetch case tags:", err);
        throw err;
      }
    },

    upsert(case_id, fileList, spis) {
      try {
        return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + starter + "/case/" + case_id + "/file/tags", {
          params: {
            fileList,
            spis
          },
          credentials: true
        });
      } catch (err) {
        console.error("[FileTagging] Failed to upsert tags:", err);
        throw err;
      }
    },

}